export default __webpack_public_path__ + "static/media/cern-medium-italic.e23ef0a9.eot";